import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function FeatureSkeleton() {
  return (
    <>
      <Skeleton height={230} borderRadius={20} className="mt-5" />

      <Skeleton height={902} borderRadius={20} className="mt-3" />
    </>
  );
}
